import { PropsWithChildren } from 'react'
import { Col } from 'components/ui/Col'

export const OnBoardingContainer = ({ children }: PropsWithChildren) => {
  return (
    <Col
      className={'tw-w-full tw-min-w-full tw-h-[100vh] tw-bg-gray-900/30'}
      justifyContent={'center'}
      alignItems={'center'}
    >
      {children}
    </Col>
  )
}
